
import { Conversation } from "@/types/conversation";
import { DBMessage } from "@/types/message";
import { Dispatch, SetStateAction } from "react";
import { useToast } from "@/hooks/use-toast";

export const useSellerResponse = (id: string | undefined) => {
  const { toast } = useToast();

  const pasteSellerResponse = async (
    conversation: Conversation | null,
    messages: DBMessage[],
    content: string,
    setMessages: Dispatch<SetStateAction<DBMessage[]>>,
    handlePasteSellerResponse: (
      conversation: Conversation,
      messages: DBMessage[],
      content: string,
      setMessages: Dispatch<SetStateAction<DBMessage[]>>
    ) => Promise<void>
  ) => {
    if (!conversation) {
      console.error("Cannot paste seller response: conversation is null");
      toast({
        variant: "destructive",
        title: "Error",
        description: "Unable to process the seller response because the conversation could not be loaded."
      });
      return;
    }
    
    await handlePasteSellerResponse(conversation, messages, content, setMessages);
  };

  return { pasteSellerResponse };
};
